import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

import { AffiliateData } from '@/__generated__/searchRefundV2Mutation.graphql';

/**
 * URL 쿼리 파라미터에서 affiliate 추적 정보를 읽어 sessionStorage에 저장하는 hook
 *
 * 지원하는 affiliate:
 * - Pincrux: appkey, pinkey 파라미터 필요
 * - Buzzvil: bz_tracking_id 파라미터 필요
 * - Adison: click_key 파라미터 필요
 */
export const useAffiliateQueryParams = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    const { appkey, pinkey, bz_tracking_id, click_key, adkey } = router.query;

    // Pincrux: appkey와 pinkey가 모두 있어야 함
    if (typeof appkey === 'string' && typeof pinkey === 'string') {
      sessionStorage.setItem('appKey', appkey);
      sessionStorage.setItem('pinKey', pinkey);
    }

    // Buzzvil: bz_tracking_id가 있으면 저장
    if (typeof bz_tracking_id === 'string') {
      sessionStorage.setItem('bzTrackingId', bz_tracking_id);
    }

    // Adison: click_key가 있으면 저장
    if (typeof click_key === 'string') {
      sessionStorage.setItem('clickKey', click_key);
    }

    // Tnk: adkey 있으면 저장
    if (typeof adkey === 'string') {
      sessionStorage.setItem('adKey', adkey);
    }
  }, [router.isReady, router.query]);
};

/**
 * sessionStorage에서 affiliate 추적 정보를 읽어오는 hook
 */
export const useAffiliateData = (): AffiliateData | null => {
  return useMemo(() => {
    const appKey = sessionStorage.getItem('appKey');
    const pinKey = sessionStorage.getItem('pinKey');
    const bzTrackingId = sessionStorage.getItem('bzTrackingId');
    const clickKey = sessionStorage.getItem('clickKey');
    const adKey = sessionStorage.getItem('adKey');

    if (appKey && pinKey) {
      return { name: 'Pincrux', appKey, trackingId: pinKey };
    }
    if (bzTrackingId) {
      return { name: 'Buzzvil', trackingId: bzTrackingId };
    }
    if (clickKey) {
      return { name: 'Adison', trackingId: clickKey };
    }
    if (adKey) {
      return { name: 'Tnk', trackingId: adKey };
    }
    return null;
  }, []);
};
